import { HttpErrorResponse, HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { Variables } from '../enum/Variables';
import { catchError } from 'rxjs/operators';

// URLs externas que NO deben recibir el token del usuario
const URL_EXCLUIDAS = [
  'service.granjazul.com'
];

@Injectable({
  providedIn: 'root'
})
export class InterceptorService implements HttpInterceptor {

  constructor() { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    // Si la URL es de un servicio externo excluido, dejarla pasar sin modificar
    const esUrlExcluida = URL_EXCLUIDAS.some(url => req.url.includes(url));
    if (esUrlExcluida) {
      return next.handle(req).pipe(
        catchError(this.manejarError)
      );
    }

    // Obtengo el token del usuario para las peticiones propias de la app
    let token = localStorage.getItem(Variables.TOKEN_LOCALSTORAGE) || '';

    // Creo el header
    const headers = new HttpHeaders({
      'token': token
    });

    // La request solo se puede usar una vez, por lo que la clono y le agrego el header
    const reqClonada = req.clone({
      headers
    });

    // Retorno la request clonada que ya contiene el token
    return next.handle(reqClonada).pipe(
      catchError(this.manejarError)
    );

  }

  // Los errores de las peticiones pasarán por aquí, por lo que se pueden guardar en algún log.
  manejarError(error: HttpErrorResponse) {
    return throwError(error['error']);
  }

}